import Immutable from 'seamless-immutable'
import Api from "../../service/api";
import {store} from "../store";

export const SETTINGS_UI_METRICS_INITIAL = {
    hits: false,
    regs: false,
    deposits: false,
    i2r: false,
    l2i: false,
};

export const INITIAL_STATE = Immutable({
    default_lang: 'en',
    default_avatar: '/images/avatar.jpg',
    asset_url: '/',
    project_name: '',
    project_logo: '',
    monetization_active: false,
    referral_program_active: false,
    referral_program_percent: 0,
    referral_program_duration_days: 0,
    min_withdraw_amount: 0,
    app_types_active: [],
    settings_ui: {
        metrics: SETTINGS_UI_METRICS_INITIAL,
    },
    isLoading: false, // isLoading flag - for internal usage (to show preloader)
});


export const SettingsAction = {
    loadInProgress: () => ({
        type: 'SETTINGS_LOADING_START',
    }),
    loadInProgressEnd: () => ({
        type: 'SETTINGS_LOADING_END',
    }),
    loadCompleted: (settings) => ({
        type: 'SETTINGS_LOADED',
        settings: settings,
    }),
    loadSettings: () => (dispatch) => {
        dispatch(SettingsAction.loadInProgress());
        return Api.getSettings()
          .then((settings) => {
              return dispatch(SettingsAction.loadCompleted(settings))
          });
    },
    updateSettings: (settingsData) => (dispatch) => {
        dispatch(SettingsAction.loadInProgress());
        return Api.updateSettings(settingsData)
          .then((updateResult) => {
              if(!updateResult.status) return Promise.reject("Something went wrong");
              return dispatch(SettingsAction.loadCompleted(updateResult.settings)); //TODO: check the path after BE is ready
          });
    },
}

function settingsLoaded(state, action) {
    //console.log('REDUX: settingsLoaded --- BEFORE merge::', {action, state});
    state = state.merge([action.settings, {isLoading: false}]);
    //console.log('REDUX: settingsLoaded --- AFTER merge::', {action, state});
    return state;
}

function settingsLoading(state, isLoading) {
    //console.log('REDUX: settingsLoading --- BEFORE merge::', {state, isLoading});
    state = state.merge({isLoading});
    //console.log('REDUX: settingsLoading --- AFTER merge::', {state, isLoading});
    return state;
}


export default function settings(
    state = INITIAL_STATE,
    action
) {
    switch (action.type) {
        case 'SETTINGS_LOADING_START':
            return settingsLoading(state, true);
        case 'SETTINGS_LOADING_END':
            return settingsLoading(state, false);
        case 'SETTINGS_LOADED':
            return settingsLoaded(state, action);
        default:
            return state;
    }
}


export function asset(assetPath, settingsState, tm = Date.now()){
    assetPath = assetPath || '';
    if(assetPath.startsWith('blob')) return assetPath;

    if(tm) assetPath = assetPath + (assetPath.indexOf('?') >= 0 ? '&' : '?') + 'tm='+tm;
    if(assetPath.startsWith('http') || assetPath.startsWith('/')) return assetPath;

    return (settingsState || store.getState().settings).asset_url + assetPath;
}

export function appTypeIsActive(settingsState, appType){
    if(!settingsState?.app_types_active || !settingsState?.app_types_active.includes(appType)) return false;
    return true;
}

